module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAMCAIAAADd4huNAAAAGklEQVQoFWP8//8/A3GAiThlIFWjSodSCAAAGogDFcYXx84AAAAASUVORK5CYII="